import React from 'react';

const VideoList = ({ children }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-5 w-full">
      {children}
    </div>
  );
};

export default VideoList;
